import React from 'react'
import { Skeleton } from 'primereact/skeleton';

export const SkeletonLoading = () => {
   return (
      <div className="flex flex-wrap">
         <div className="w-full md:w-6 p-3">
            <Skeleton width="10rem" className="mb-2"></Skeleton>
            <Skeleton width="5rem" className="mb-2"></Skeleton>
         </div>
      </div>
   )
}
